import React, { FC } from 'react';
import { fixed } from 'helicon/build';
import { ValueInputProps } from './ValueInput';
import { FloatInput } from './FloatInput';

export const FloatFixedValueInput: FC<ValueInputProps<number>> = ({
  id,
  tabIndex,
  disabled,
  seededValue,
  onChange,
}) => {
  return (
    <FloatInput
      id={id}
      tabIndex={tabIndex}
      disabled={disabled}
      value={seededValue}
      onChange={value => onChange(fixed(value))}
    />
  );
};
